"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _checkboxOption = require("./checkbox.option.proptypes");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var OptionWrapper = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__OptionWrapper",
  componentId: "sc-13gxc8j-0"
})(["display:flex;align-items:", ";flex-direction:row;cursor:pointer;margin-bottom:", ";pointer-events:", ";"], function (_ref) {
  var disableAlignment = _ref.disableAlignment;
  return disableAlignment ? 'initial' : 'center';
}, function (props) {
  return !props.disableBottomMargin && props.theme.space.medium;
}, function (_ref2) {
  var disable = _ref2.disable;
  return disable && 'none';
});

var CheckBox = _styledComponents.default.span.withConfig({
  displayName: "Checkbox__CheckBox",
  componentId: "sc-13gxc8j-1"
})(function (_ref3) {
  var checked = _ref3.checked,
      theme = _ref3.theme,
      isReversed = _ref3.isReversed,
      disabledWithSelected = _ref3.disabledWithSelected,
      activeColor = _ref3.activeColor,
      borderColor = _ref3.borderColor;
  return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  border-radius: ".concat(theme.borderRadius.small, ";\n  border: 1px solid ").concat(borderColor ? theme.colors[borderColor] : theme.colors.greyLight, ";\n  background: ").concat(checked ? activeColor || "".concat(theme.colors.secondary) : "".concat(disabledWithSelected ? theme.colors.greyLight : theme.colors.default), ";\n  &:focus {\n    border: 1px solid ").concat(activeColor || theme.colors.secondary, ";\n  }\n\n  ").concat(isReversed ? "\n          order: 2;\n        " : '', "\n");
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__Wrapper",
  componentId: "sc-13gxc8j-2"
})(function (_ref4) {
  var theme = _ref4.theme,
      isReversed = _ref4.isReversed,
      isFullWidth = _ref4.isFullWidth;
  return "\n    display: flex;\n    gap: 3px;\n  ".concat(isReversed ? "\n          order: 1;\n          ".concat(isFullWidth && "width: 100%;", "\n          margin-left: ").concat(theme.space.none, ";\n        ") : "\n          margin-left: ".concat(theme.space.XSmall, ";\n      "), "\n");
});

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__TextContainer",
  componentId: "sc-13gxc8j-3"
})(["margin-left:auto;"]);

var Checkbox = function Checkbox(_ref5) {
  var isSelected = _ref5.isSelected,
      text = _ref5.text,
      onChange = _ref5.onChange,
      theme = _ref5.theme,
      accessible = _ref5.accessible,
      customProperties = _ref5.customProperties,
      isReversed = _ref5.isReversed,
      disableCheckbox = _ref5.disableCheckbox,
      disableBottomMargin = _ref5.disableBottomMargin,
      isFullWidth = _ref5.isFullWidth,
      textCustomProperties = _ref5.textCustomProperties,
      disabledWithSelected = _ref5.disabledWithSelected,
      disableAlignment = _ref5.disableAlignment,
      icon = _ref5.icon,
      iconCustomProperties = _ref5.iconCustomProperties,
      boldText = _ref5.boldText,
      value = _ref5.value,
      activeColor = _ref5.activeColor,
      borderColor = _ref5.borderColor;

  var handelKeyDown = function handelKeyDown() {
    return function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        onChange(!isSelected);
      }
    };
  };

  (0, _react.useEffect)(function () {
    if (disableCheckbox) onChange(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableCheckbox]);
  var tabIndex = accessible ? 0 : -1;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(OptionWrapper, {
      className: "check-box",
      onMouseDown: function onMouseDown() {
        return onChange(!isSelected);
      },
      onKeyDown: handelKeyDown(),
      tabIndex: tabIndex,
      disable: disableCheckbox,
      disableBottomMargin: disableBottomMargin,
      disableAlignment: disableAlignment
    }, /*#__PURE__*/_react.default.createElement(CheckBox, (0, _extends2.default)({
      isReversed: isReversed,
      checked: isSelected
    }, customProperties, {
      tabIndex: tabIndex,
      disabledWithSelected: disabledWithSelected,
      activeColor: activeColor,
      borderColor: borderColor
    }), (isSelected || disabledWithSelected) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: "default",
      icon: "CheckIcon",
      fontsize: "normal",
      accessible: false
    })), /*#__PURE__*/_react.default.createElement(Wrapper, {
      isReversed: isReversed,
      isFullWidth: isFullWidth,
      accessible: false
    }, icon && /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
      accessible: false,
      color: "neutral",
      fontsize: "titleNormal",
      icon: icon,
      theme: theme
    }, iconCustomProperties)), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      bold: boldText,
      color: "neutral",
      type: "sub",
      customProperties: _objectSpread({}, textCustomProperties)
    }, text)), value && /*#__PURE__*/_react.default.createElement(TextContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      bold: boldText,
      color: _constants.VALUE.COLOR,
      type: _constants.VALUE.TYPE,
      accessible: false,
      theme: theme
    }, value)));
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Checkbox.propTypes = _checkboxOption.CheckboxPropTypes.PropTypes;
Checkbox.defaultProps = _checkboxOption.CheckboxPropTypes.DefaultProps;
var _default = Checkbox;
exports.default = _default;